<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Radio, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { format } from 'svelte-i18n';
	//Stores
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	let settings = readDeviceSettings(device.id);
	let selected: string = settings['em:0']?.blink_mode_selector;
	let cacheSelected: string = selected;
	let loading: boolean = false;

	const modes = ['active_energy', 'apparent_energy'];
	const modesTranslated = [
		$format('label_active_energy', { default: 'Active energy' }),
		$format('label_apparent_energy', { default: 'Apparent energy' }),
	];

	const changeMode: (mode: string) => void = (mode: string) => {
		selected = mode;
	};

	const setMode: () => Promise<void> = async () => {
		if (cacheSelected !== selected) {
			loading = true;
			const res = await gen2Request(device, 'em.SetConfig', {
				id: 0,
				config: { blink_mode_selector: selected },
			});
			let response = onSettingsResponse(res, device);
			if (!response) {
				selected = cacheSelected;
			} else {
				cacheSelected = selected;
				settings['em:0'].blink_mode_selector = selected;
				devices_settings.update_devices_settings(real_id(device.id), settings);
			}
			loading = false;
		}
	};
</script>

<Text class="mb-s" styleType="body-small"
	>{$format('blink_mode_selector_description', {
		default: 'Select the electrical quantity that drives the LED indicator.',
	})}</Text
>

{#each modes as mode, i}
	<Radio
		size="m"
		class="mb-s"
		bind:selected
		value={mode}
		on:click={() => changeMode(mode)}
		id="radio-14k8tz2"
	>
		{modesTranslated[i]}
	</Radio>
{/each}
<Button size="m" width="full" {loading} on:click={setMode}>{$format('button_save')}</Button>
